import { Box, Image, List, RadioButton, Text } from 'grommet'
import { AdModel } from '../../../../models/AdModel'
import React, { useCallback, useEffect, useState } from 'react'
import { UploadDropZone } from '../../../../components/media/UploadDropZone'
import { useCurrentCampaign } from '../../../../hooks/useCurrentCampaign'
import { deleteMedia, imagesForReferredId, MediaDTO } from '../../../../api/media'
import { useAdDetailContext } from '../AdDetailContext'
import { Trash } from 'phosphor-react'

export const AdDetailImages = ({currentAd}: { currentAd: AdModel }) => {
    const campaign = useCurrentCampaign()
    const {updateCurrentAdImage} = useAdDetailContext()
    const [mediaDTOs, setMediaDTOs] = useState<MediaDTO[] | undefined>()

    useEffect(() => {
        if(campaign) {
            imagesForReferredId(campaign.id).then(response => {
                response && setMediaDTOs(response)
            })
        }
    }, [campaign])

    const handleUpload = useCallback((response: MediaDTO) => {
        setMediaDTOs(mediaDTOs?.concat([response]))
    }, [setMediaDTOs, mediaDTOs])

    const handleDelete = useCallback((id) => {
        deleteMedia(id).then(() => {
            setMediaDTOs(mediaDTOs?.filter(data => data.id !== id))
        })
    }, [mediaDTOs])

    return <Box height={{min: 'auto'}}
                direction={'column'}
                gap={'medium'}>
        <UploadDropZone accept={'image/*'}
                        subTitle={'(Es werden nur Bilder vom Typ *.jpg/jpeg/bmp/png akzeptiert)'}
                        handleUpload={handleUpload}/>
        <Box direction={'column'}>
            <Text>Wählen Sie ein Bild für Ihre Stellenanzeige aus:</Text>
            <List data={mediaDTOs}
                  onClickItem={({item}: { item?: MediaDTO }) => {
                      item && updateCurrentAdImage(item.id)
                  }}
                  action={(item) => (
                      currentAd.image?.id !== item.id ?
                          <Trash size={'24px'}
                                 onClick={(event) => {
                                     event.stopPropagation()
                                     handleDelete(item.id)
                                 }}/> : null
                  )}>
                {(data: MediaDTO) => (
                    <Box direction={'row'} gap={'medium'} align={'center'}>
                        <RadioButton name={''} checked={currentAd.image?.id === data.id} readOnly/>
                        <Box width={'small'}><Image src={data.url}/></Box>
                        <Text>Dateiname: {data.fileName}</Text>
                    </Box>
                )}
            </List>
        </Box>
    </Box>
}


